import { post } from "../api_helper";

export const authService = (email, password) => {
    return post("/admin/login", { email, password });
}

export const changePassword = (oldPassword, newPassword) => {
    return post("/admin/change_password", { oldPassword, newPassword });
}
export const forgetPassword = (email) => {
    return post("/admin/forgot_password", { email });
}

export const resetPassword = (email, otp, password) => {
    return post("/admin/verify_otp", { email, otp, password });
}

export const updateFCMToken = (fcmToken) => {
    return post("/admin/update/device_token", { device_token: fcmToken });
}

export const createSubAdmin = (subAdminData) => {
    return post("/admin/create_sub_admin", subAdminData);
}

export const createBranchOwner = (branchOwnerData) => {
    return post("/admin/create_branch_owner", branchOwnerData);
}
